import { Resume } from '@/types/resume/v1'
import { Paragraph, SectionType, HeadingLevel, ISectionOptions } from 'docx'

const languages = ({ languages }: Resume.Schema): ISectionOptions => {
  const languageList = languages
    .filter(l => l.language)
    .map(l => {
      if (!l.fluency) return l.language
      return `${l.language} (${l.fluency})`
    })
    .join(', ')
  return {
    properties: {
      type: SectionType.CONTINUOUS,
    },
    children: [
      new Paragraph({
        text: '\n',
      }),
      new Paragraph({
        text: 'Languages',
        heading: HeadingLevel.HEADING_2,
      }),
      new Paragraph({
        text: '\n',
      }),
      new Paragraph({
        text: languageList,
      }),
    ],
  }
}

export default languages
